import { forwardRef, useEffect, useState, type InputHTMLAttributes } from 'react';
import { groupThousands, parseFcfa } from '@zakat/shared';
import { cn } from './cn';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'type'> & {
  value: number;
  onValueChange: (value: number) => void;
  suffix?: string;
};

/** Saisie de montant FCFA : clavier numérique, espaces des milliers en direct, entier uniquement. */
export const AmountInput = forwardRef<HTMLInputElement, Props>(function AmountInput({ value, onValueChange, suffix = 'FCFA', className, ...rest }, ref) {
  const [text, setText] = useState(value ? groupThousands(value) : '');

  useEffect(() => {
    if ((parseFcfa(text) ?? 0) !== value) setText(value ? groupThousands(value) : '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <div className="relative">
      <input
        ref={ref}
        type="text"
        inputMode="numeric"
        autoComplete="off"
        pattern="[0-9 ]*"
        value={text}
        onChange={(e) => {
          const digits = e.target.value.replace(/\D/g, '').slice(0, 12);
          const n = digits ? Number(digits) : 0;
          setText(digits ? groupThousands(n) : '');
          onValueChange(n);
        }}
        className={cn(
          'block min-h-[52px] w-full rounded-xl border border-sand-300 bg-white py-3 pl-4 pr-16 text-right text-lg font-bold tabular-nums text-ink focus:border-brand-800 focus:outline-none focus:ring-2 focus:ring-gold-500/60 aria-[invalid=true]:border-[#9B2C1F]',
          className,
        )}
        {...rest}
      />
      <span className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-xs font-bold text-gray-600" aria-hidden="true">
        {suffix}
      </span>
    </div>
  );
});
